( function( $ ) {
    "use strict";

    var BookingArtist = {};

    BookingArtist.onChangeContracted = function() {
        $(this).trigger('refresh');
    };

    BookingArtist.onRefreshContracted = function() {
        var $contractedInput = $(this),
            $formEntry = $contractedInput.closest('[data-form-entry="booking-artist"]'),
            $durationInput = $formEntry.find('[data-form-control="duration"]'),
            $intermissionInput = $formEntry.find('[data-form-control="intermission"]'),
            $noteContractInput = $formEntry.find('[data-form-control="note-contract"]');

        $noteContractInput.toggleClass('ghost', !$contractedInput.prop('checked'));

        BookingArtist.refreshDurationState($durationInput);
        BookingArtist.refreshIntermissionState($intermissionInput);
    };

    BookingArtist.onChangeDurationUndefined = function() {
        $(this).trigger('refresh');
    };

    BookingArtist.onRefreshDurationUndefined = function() {
        var $durationUndefinedInput = $(this),
            $formEntry = $durationUndefinedInput.closest('[data-form-entry="booking-artist"]'),
            $durationWidget = $formEntry.find('[data-form-control="duration-widget"]'),
            $intermissionWidget = $formEntry.find('[data-form-control="intermission-widget"]'),
            $durationInput = $formEntry.find('[data-form-control="duration"]'),
            $intermissionInput = $formEntry.find('[data-form-control="intermission"]');

        $durationWidget.toggleClass('hidden', $durationUndefinedInput.prop('checked'));
        $intermissionWidget.toggleClass('hidden', $durationUndefinedInput.prop('checked'));

        BookingArtist.refreshDurationState($durationInput);
        BookingArtist.refreshIntermissionState($intermissionInput);
    };

    BookingArtist.refreshDurationState = function($durationInput) {
        var $formEntry = $durationInput.closest('[data-form-entry="booking-artist"]'),
            $contractedInput = $formEntry.find('[data-form-control="contracted"]'),
            $durationUndefinedInput = $formEntry.find('[data-form-control="duration-undefined"]');

        $durationInput.prop('required', $contractedInput.prop('checked') && !$durationUndefinedInput.prop('checked'));
    };

    BookingArtist.refreshIntermissionState = function($intermissionInput) {
        var $formEntry = $intermissionInput.closest('[data-form-entry="booking-artist"]'),
            $contractedInput = $formEntry.find('[data-form-control="contracted"]'),
            $durationUndefinedInput = $formEntry.find('[data-form-control="duration-undefined"]');

        $intermissionInput.prop('required', $contractedInput.prop('checked') && !$durationUndefinedInput.prop('checked'));
    };

    var $body = $('body');

    $body.on('app.init', function(ev) {
        var $container = $(ev.container),
            $formEntries = $container.find('form [data-form-entry="booking-artist"]'),
            $contractedInputs = $formEntries.find('[data-form-control="contracted"]'),
            $durationUndefinedInputs = $formEntries.find('[data-form-control="duration-undefined"]');

        $contractedInputs
            .on('change.bookingartist', BookingArtist.onChangeContracted)
            .on('refresh.bookingartist', BookingArtist.onRefreshContracted);

        $durationUndefinedInputs
            .on('change.bookingartist', BookingArtist.onChangeDurationUndefined)
            .on('refresh.bookingartist', BookingArtist.onRefreshDurationUndefined)
            .trigger('refresh.bookingartist');
    });

}( jQuery ));
